import React from 'react';
import Icon from '../atoms/Icon';

function EmailIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 23">
      <g fill='currentColor' fillRule='evenodd'>
        <path d="M32 0V22.1538H0V0H32ZM2.46154 19.6923H29.5385V2.46154H2.46154V19.6923Z"/>
        <path d="M31.4519 2.2548L16 12.5565L0.548065 2.2548L1.91345 0.206726L16 9.59735L30.0865 0.206726L31.4519 2.2548Z"/>
        <path d="M31.4748 16.2223L30.0637 18.2392L17.756 9.62379L19.1671 7.60696L31.4748 16.2223Z"/>
        <path d="M14.244 9.62379L1.9363 18.2392L0.525238 16.2223L12.8329 7.60696L14.244 9.62379Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(EmailIcon);